<template>
    <SmallSquare content="数据只统计到昨天，统计消费者在门店核销的数据" :padding='true' />
     <a-card :bordered="false">
         <a-form class="m-t-10 m-b-20" layout='inline'>
         <a-form-item label="核销日期">
            <a-range-picker v-model:value="time" :disabledDate="disabledDate" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="changeData" />
         </a-form-item>
         <a-form-item>
             <a-input-group compact :style="{width:'380px'}">
                 <a-select v-model:value="search.key_type" style="width:150px">
                     <a-select-option  value="store_name">核销门店</a-select-option>
                      <a-select-option value="parent_name">门店所属上级</a-select-option>
                 </a-select>
                 <a-input type="text" style="width:60%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索"></a-input>
             </a-input-group>
         </a-form-item>
          <a-form-item >
              <a-button type="primary" @click="search.page=1;initData();getWriteNumber()">搜索</a-button>
          </a-form-item>
          <a-form-item >
              <a-button type="primary" ghost v-has:storeWriteExport="()=>{exportTable()}">导出</a-button>
          </a-form-item>
     </a-form>
      <a-card :bordered="false">
          <div class="s_flex text-ac">
              <div class="p-t-30 p-b-30 item" style="width:240px;">
                   <p class="fz-16">参与核销门店数</p>
                   <p class="fz-26 s_font_b m-t-5">{{writeData.all_write_store_num || 0}}</p>
               </div>
               <div class="m-l-30 p-t-30 p-b-30 item" style="width:240px;">
                   <p class="fz-16">核销总次数</p>
                   <p class="fz-26 s_font_b m-t-5">{{writeData.all_write_num || 0}}</p>
               </div>
               <div class="m-l-30 p-t-30 p-b-30 item" style="width:240px;">
                   <p class="fz-16">核销礼品总数</p>
                   <p class="fz-26 s_font_b m-t-5">{{writeData.all_write_gift_num || 0}}</p>
               </div>
          </div>
      </a-card>
     <a-table :pagination='pagination' :loading='loading' bordered rowKey='id' :columns='columns' :data-source='list' class="m-t-20" @change="changePage"></a-table>
     </a-card>
</template>

<script>
import {writeNumber,writeStatistics} from "@/api/assets";
import { toRefs,reactive,ref, onMounted } from 'vue'
 import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
   import moment from 'moment'
const columns = [
    {
        title: "门店名称",
        dataIndex: "write_store_name",
    },
    {
        title: "门店所属上级",
        dataIndex: "dealer_name",
    },
    {
         title: "核销次数",
        dataIndex: "write_num",
    },
    {
        title: "核销礼品数",
        dataIndex: "write_gift_num",
    },
]


export default{
    setup(){
        const search = ref({
            key_type:'store_name',
            keyword:'',
             start_time: "",
              end_time: "", 
              page: 1,
              limit: 10,
        })
        const state = reactive({
            time:[],
            loading:false,
            list:[],
             pagination:{ 
              total:0,
              current:1,
              pageSize:10,
               defaultPageSize:10,
               showSizeChanger:true, 
               pageSizeOptions:['5','10', '20', '30', '40', '50'], 
               showQuickJumper:true, 
               showTotal:(total)=> `共 ${total} 条`
             },
             writeData:{},
              disabledDate:function(date){
                 return date && date > moment().subtract(1, "days")
             }
 
        })
        const methods= {
            changeData(e){
                search.value.start_time = e[0];
                search.value.end_time = e[1];
                console.log(search)
            },
            changePage(e){
                 state.pagination.pageSize = e.pageSize;
                 state.pagination.current = e.current;
                 search.value.limit = e.pageSize;
                 search.value.page = e.current;
                 methods.initData()
            },
            seeMemberInfo(record){
                console.log(record)
                state.showGift = true;
            },
            async getWriteNumber(){
                let result =await writeNumber({...search.value}).then(res=>res.data);
                if(iscode(result)) {
                   state.writeData = result.data || {};
                }else{
                    message.error(result.msg)
                }
            },
           async initData(){
               state.loading = true;
               state.list = [];
                let result = await writeStatistics({...search.value}).then(res=>res.data)
                state.loading=false;
                 if(iscode(result)) {
                   state.list = result.data.data;
                   state.pagination.total = result.data.total || 0;
                }else{
                    message.error(result.msg)
                }
            },
       async exportTable(){
               const hide = message.loading('正在加载中...', 0);
               let result = await writeStatistics({...search.value,excel:1}).then(res=>res.data).catch(error=>error);
               if(iscode(result,true)){
                 window.open(result.data.action)
               }
               setTimeout(hide);
             }
        }
        onMounted(()=>{
            methods.getWriteNumber()
            methods.initData()
        })
        return{
            ...toRefs(state),
            search,
            ...methods,
            columns,
        }
    }
}
</script>

<style lang="less" scoped>
.item{
  box-shadow:6px 8px 20px 0 rgba(0,0,0,.3);
  // inset -3px -2px 7px 0 rgb(0 0 0 / 30%)
  border-radius: 8px;
}

</style>
